/**
 * <StudentInfoTD
 *		student={studentObject}
 *	/>
 *
 * - This goes into <td> of "student" column and display
 *   an avatar, student's name and age
 *
 * @parent Table (but passed by student-table-field)
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router'
import StudentName from 'components/StudentName';
import __R, { userCan } from 'containers/__R'
import PhotoViewer from 'template/Modals/Photo';
import { hotline } from 'vendor/react-redux-hotline';

const MALE_IMG = require('data/images/Male_student.png');
const FEMALE_IMG = require('data/images/Female_student.png');
const NEUTRAL_IMG = require('data/images/default-logo.png');

class StudentInfoTD extends React.Component {
  constructor(props) {
    super(props);

    this.viewPhoto = this.viewPhoto.bind(this);
	}

	static propTypes = {
		studentInfo: PropTypes.object.isRequired
  }

  viewPhoto() {
    const {
      profile_photo_thumbnail_8x
    } = this.props.studentInfo;

    if (!profile_photo_thumbnail_8x) {
      return;
    }

    PhotoViewer({ photo: profile_photo_thumbnail_8x });
	}
	checkStudentUpdate(isUpdated) {
    if(isUpdated){
			this.props.student.fetchStudent('after enrolled at a class @classInfoTD', this.props.student.studentState)
    }
	}
	render() {
		let { studentInfo } = this.props;

		let {
			schoolStudentID,
			sName,
      sAge,
		} = studentInfo;

    const hasPhoto = studentInfo.profile_photo_thumbnail_8x != '';

		let image;
		if (studentInfo.profile_photo_thumbnail_2x) {
			image = `url(${studentInfo.profile_photo_thumbnail_2x})`;
		}else {
			if (studentInfo.sGender == 0){
				image = `url(${MALE_IMG})`
			} else if (studentInfo.sGender == 1){
				image = `url(${FEMALE_IMG})`
			} else if (studentInfo.sGender == 3){
				image = `url(${NEUTRAL_IMG})`
			}
		}

		if (!sName) {
			return <div></div>;
		}

		return (
			<div className="student-info-container">
				<div className={classnames("portrait", { hasPhoto })} style={{
					backgroundImage: image
        }} onClick={this.viewPhoto}>
				</div>
				<div className="text-container">
					<div className="name">
            {/* <__R can='read_student_detail' by='disable'> */}
              <StudentName name={sName} id={schoolStudentID} checkStudentUpdate={(isUpdated)=>this.checkStudentUpdate(isUpdated)}/>
            {/* </__R> */}
						{ typeof(sAge) !== 'undefined' && sAge !== null &&
            <small>
              {__("{sAge} yrs old", "student.table", { sAge }, true)}
            </small>
          }
					</div>
				</div>
			</div>
		);
  }
}

// export default StudentInfoTD;
export default hotline(StudentInfoTD, 'student');



// WEBPACK FOOTER //
// ./src/containers/pages/Student/StudentTable/StudentInfoTd.js